import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalRoot,
} from '@creditas-ui/react';
import React from 'react';
import { useEjnActions } from '../../../hook/useEjnActions';

const EjnSendToProtestComponent: React.FC = () => {
  const { onClose, sendToProtestVisible } = useEjnActions();

  return (
    <ModalRoot closeModal={onClose} size="medium" isOpen={sendToProtestVisible}>
      <ModalHeader title="Enviar para protesto" />
      <ModalBody>Modal</ModalBody>
      <ModalFooter
        onPrimaryButtonClick={() => undefined}
        onSecondaryButtonClick={onClose}
        primaryLabel="Submit"
        secondaryLabel="Cancel"
      />
    </ModalRoot>
  );
};

const EjnSendToProtest = React.memo(EjnSendToProtestComponent);

export default EjnSendToProtest;
